// style
import "./style.scss";

export const SearchCardsSkeleton = () => {
	const cardLeft = <div className="skeleton__left"></div>;

	const cardRight = (
		<div className="skeleton__right">
			<div className="skeleton__card__title"></div>
			<div className="skeleton__card__location"></div>
			<div className="skeleton__card__type"></div>
			<div className="skeleton__card__benefits"></div>
			<div className="skeleton__card__reviews"></div>
		</div>
	);

	return (
		<div className="skeleton__card">
			{cardLeft}
			{cardRight}
		</div>
	);
};
